export default __webpack_public_path__ + "static/media/221091_provider_sum.8199e641.pdf";